/* eslint-disable arrow-body-style */

import React from 'react';

// Custom
import modelIzlet from "@/models/izlet";
import modelIzletDan from '@/models/izlet_dan';
import DataCentricPage from "@/views/DataCentric/DataCentricPage";
import REGIzletForm from './Forms/REGIzletForm';
import { Permissions } from "@/lib/permissions";

const RegisteredUserIzletiPage = () => {
  return (
    <DataCentricPage
      needPermission={[Permissions.HPSKomisijaView, Permissions.Administration]}

      primaryModel={modelIzlet}
      primaryTitleToken="titles.izleti_reg_user"
      primaryView="reg"
      primaryAllowAdd={false}
      primaryAllowView={false}
      primaryDialogForm="reg"
      primaryDialogComponent={REGIzletForm}
      primaryAllowEdit={false}
      primaryAllowGeneratePDF={false}
      primaryAllowShareIzlet={false}
      primaryAllowGenerateVodickiObrazac={false}
      primaryOverrideAPIUrl="reg/izleti"
      primaryExportLabel="buttons.export_xlsx_izleti"
      
      secondaryModel={modelIzletDan}
      secondaryTitleToken='titles.dani'
      secondaryView="reg"
      secondaryAllowView={false}
      
      baseRecordPath="reg/izleti"
      childRecordRelativePath='dani'
      geomRelativePath=""
      miniMapBaseRecordQueryParams="?type=reg"
      
      mapId={10}
      mapModel={modelIzlet}
    />
  )
};

export default RegisteredUserIzletiPage;
